export default "__VITE_ASSET__VWn7TmKT__"